import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { createStoreWithSelectors } from 'common/util/zustand';
/**
 * since the sort won't add or remove entries from the filtered list,
 * we can use a separate store to only "re-organize" the filteredLots on
 * sort state change
 */
const MonthlyPaymentStore = create(subscribeWithSelector((set) => ({
    isMonthlyPaymentApiReady: false,
    setIsMonthlyPaymentApiReady: (isMonthlyPaymentApiReady) => set(() => ({ isMonthlyPaymentApiReady: isMonthlyPaymentApiReady })),
    monthlyPayments: new Map(),
    setMonthlyPayment: (lotId, MonthlyPayment) => {
        set((prev) => ({ monthlyPayments: new Map(prev.monthlyPayments).set(lotId, MonthlyPayment) }));
    }
})));
const useMonthlyPaymentStore = createStoreWithSelectors(MonthlyPaymentStore);
export default useMonthlyPaymentStore;
